import styled from 'styled-components'
import { BLACK, GRAYSCALE_100, WHITE } from '@styles/colors'
import { INTER } from '@styles/fonts'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${GRAYSCALE_100};
`

export const SettingItem = styled.div`
  padding: 16px;
  background-color: ${WHITE};
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const SettingLabel = styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: ${BLACK};
`

export const NotificationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${BLACK};
  width: 100%;
  padding: 12px;
  font-family: ${INTER.regular};
  font-size: 13px;
`
